import React, {useState} from 'react';

const BASE=process.env.REACT_APP_API_URL||'http://localhost:5000';

async function request(path,body,token){
  const r=await fetch(`${BASE}/auth/password${path}`,{
    method:body?'POST':'GET',
    cache:'no-store',
    headers:{'Content-Type':'application/json',...(token?{'x-auth-token':token}:{})},
    ...(body?{body:JSON.stringify(body)}:{})
  });
  const d=await r.json();
  if(!r.ok)throw new Error(d.error||'Request failed');
  return d;
}

const fieldStyle={
  width:'100%',boxSizing:'border-box',padding:'12px 14px',marginTop:6,
  border:'1px solid #ced9e8',borderRadius:10,color:'#14213d',background:'#fff',
  outline:'none',fontSize:14,boxShadow:'0 1px 2px rgba(15,35,70,.04)'
};
const labelStyle={display:'block',marginBottom:13,fontSize:12,fontWeight:750,color:'#4a5a73'};
const primaryStyle={
  width:'100%',border:0,borderRadius:10,padding:'12px 16px',cursor:'pointer',
  color:'#fff',fontWeight:800,fontSize:14,background:'linear-gradient(135deg,#1d4ed8,#4f46e5)',
  boxShadow:'0 8px 18px rgba(37,99,235,.22)'
};
const linkStyle={border:0,background:'transparent',color:'#2457b8',fontWeight:750,cursor:'pointer',padding:'8px 2px'};

export default function PasswordAccess({account=false,isOwner=false}){
  const [setupToken]=useState(()=>new URLSearchParams(window.location.hash.slice(1)).get('password-setup')||'');
  const [mode,setMode]=useState(setupToken?'setup':'login');
  const [workspace,setWorkspace]=useState('');
  const [username,setUsername]=useState('');
  const [password,setPassword]=useState('');
  const [confirm,setConfirm]=useState('');
  const [email,setEmail]=useState('');
  const [message,setMessage]=useState('');
  const [isError,setIsError]=useState(false);
  const [busy,setBusy]=useState(false);
  const [expanded,setExpanded]=useState(false);

  async function submit(e){
    e.preventDefault();setBusy(true);setMessage('');setIsError(false);
    try{
      if(account){
        const d=await request('/invite',email?{email}:{},localStorage.getItem('erp_token'));
        setMessage(d.message);
      }else if(mode==='setup'){
        if(password!==confirm)throw new Error('Passwords do not match.');
        await request('/setup',{token:setupToken,username,password});
        setPassword('');setConfirm('');
        window.history.replaceState({},'',window.location.pathname);
        setMode('login');
        setMessage('Password saved. Sign in with your workspace code and username.');
      }else if(mode==='recover'){
        const d=await request('/recover',{workspace,email});
        setMessage(d.message);
      }else{
        const d=await request('',{workspace,username,password});
        localStorage.setItem('erp_token',d.token);
        localStorage.removeItem('cached_user');
        window.location.replace('/');
      }
    }catch(e){setIsError(true);setMessage(e.message);}finally{setBusy(false);}
  }

  async function open(){
    const next=!expanded;setExpanded(next);setMessage('');setIsError(false);
    if(next){
      try{setWorkspace((await request('/workspace',null,localStorage.getItem('erp_token'))).workspace);}
      catch(e){setIsError(true);setMessage(e.message);}
    }
  }

  if(account&&!expanded){
    return <button className="sidebar-logout" onClick={open}>🔐 Password &amp; workspace</button>;
  }

  const title=account?'Workspace access':mode==='setup'?'Create your staff login':mode==='recover'?'Recover workspace access':'Sign in to WAVELINES ERP';
  const subtitle=account
    ?'Manage secure workspace access for yourself and invited staff.'
    :mode==='setup'
      ?'Choose credentials for the business workspace that invited you.'
      :mode==='recover'
        ?'We will send a secure, single-use setup link when the account matches.'
        :'Use the workspace code supplied by your business owner.';

  return <section style={{
    marginTop:account?16:18,textAlign:'left',border:'1px solid #d9e3f0',borderRadius:18,
    background:'#fff',color:'#172033',overflow:'hidden',boxShadow:'0 16px 40px rgba(25,54,96,.12)'
  }}>
    <div style={{padding:'22px 24px',background:'linear-gradient(135deg,#123a78,#4f46e5)',color:'#fff'}}>
      <div style={{display:'flex',alignItems:'center',gap:13}}>
        <div style={{width:42,height:42,borderRadius:12,display:'grid',placeItems:'center',background:'rgba(255,255,255,.16)',fontSize:21}}>🔐</div>
        <div>
          <div style={{fontSize:11,fontWeight:850,letterSpacing:'.12em',opacity:.78}}>SECURE WORKSPACE ACCESS</div>
          <h2 style={{fontSize:20,lineHeight:1.25,margin:'5px 0 0',color:'#fff'}}>{title}</h2>
        </div>
      </div>
      <p style={{fontSize:13,lineHeight:1.55,margin:'13px 0 0',opacity:.88}}>{subtitle}</p>
    </div>

    <div style={{padding:'22px 24px'}}>
      {account&&<div style={{marginBottom:18,padding:'13px 15px',borderRadius:11,background:'#f3f7fd',border:'1px solid #dce7f5'}}>
        <div style={{fontSize:10,fontWeight:850,letterSpacing:'.09em',color:'#6a7890'}}>WORKSPACE CODE</div>
        <div style={{marginTop:5,font:'750 17px ui-monospace,SFMono-Regular,Consolas,monospace',color:'#173d78',overflowWrap:'anywhere'}}>{workspace||'Loading…'}</div>
      </div>}

      <form onSubmit={submit}>
        {!account&&mode!=='setup'&&<label style={labelStyle}>Workspace code
          <input style={fieldStyle} required autoComplete="organization" placeholder="WS-…" value={workspace} onChange={e=>setWorkspace(e.target.value)}/>
        </label>}

        {!account&&mode!=='recover'&&<>
          <label style={labelStyle}>Username
            <input style={fieldStyle} required minLength={3} maxLength={32} autoComplete="username" placeholder="Your workspace username" value={username} onChange={e=>setUsername(e.target.value)}/>
          </label>
          <label style={labelStyle}>{mode==='setup'?'Create password':'Password'}
            <input style={fieldStyle} required type="password" minLength={mode==='setup'?10:1} maxLength={128} autoComplete={mode==='setup'?'new-password':'current-password'} placeholder={mode==='setup'?'At least 10 characters':'Your password'} value={password} onChange={e=>setPassword(e.target.value)}/>
          </label>
          {mode==='setup'&&<label style={labelStyle}>Confirm password
            <input style={fieldStyle} required type="password" minLength={10} maxLength={128} autoComplete="new-password" placeholder="Repeat your password" value={confirm} onChange={e=>setConfirm(e.target.value)}/>
          </label>}
        </>}

        {(mode==='recover'||(account&&isOwner))&&<label style={labelStyle}>{account?'Staff email (leave blank for your own)':'Account email'}
          <input style={fieldStyle} type="email" required={!account} autoComplete="email" placeholder={account?'staff@example.com':'you@example.com'} value={email} onChange={e=>setEmail(e.target.value)}/>
        </label>}

        <button style={{...primaryStyle,opacity:busy?.68:1}} type="submit" disabled={busy}>
          {busy?'Please wait…':account||mode==='recover'?'Email secure setup link':mode==='setup'?'Create staff login':'Sign in securely'}
        </button>
      </form>

      {message&&<div role="status" style={{
        marginTop:15,padding:'11px 13px',borderRadius:10,fontSize:12.5,lineHeight:1.5,
        border:`1px solid ${isError?'#fecaca':'#bbf7d0'}`,
        background:isError?'#fff1f2':'#f0fdf4',color:isError?'#9f1239':'#166534'
      }}>{message}</div>}

      {!account&&mode!=='setup'&&<button style={{...linkStyle,marginTop:12}} type="button" onClick={()=>{setMode(mode==='login'?'recover':'login');setMessage('');setIsError(false);}}>
        {mode==='login'?'Set up or recover password →':'← Back to password sign-in'}
      </button>}

      {!account&&mode==='recover'&&<p style={{fontSize:12,lineHeight:1.55,color:'#68768c',margin:'8px 0 0'}}>
        Your business owner can share the workspace code. Existing Google users may also sign in with Google and open Password &amp; workspace.
      </p>}

      {account&&<button style={{...linkStyle,marginTop:10}} type="button" onClick={()=>setExpanded(false)}>Close workspace access</button>}
    </div>
  </section>;
}
